import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

const CAPTURE_OPTIONS = {
  scale: 2,
  useCORS: true,
  allowTaint: false,
  backgroundColor: '#ffffff',
  logging: false,
  imageTimeout: 15000,
};

export function downloadBlobFile(blob, fileName) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

export function cropCanvas(source, sy, sh) {
  const safeY = Math.max(0, Math.min(source.height, Math.floor(sy)));
  const safeH = Math.max(1, Math.min(source.height - safeY, Math.ceil(sh)));
  const pageCanvas = document.createElement('canvas');
  pageCanvas.width = source.width;
  pageCanvas.height = safeH;
  const ctx = pageCanvas.getContext('2d');
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, pageCanvas.width, pageCanvas.height);
  ctx.drawImage(source, 0, safeY, source.width, safeH, 0, 0, source.width, safeH);
  return pageCanvas;
}

function paintPageFooter(pdf, { page, totalPages, footerText, pageWidth, pageHeight, margin, footerHeight }) {
  pdf.setFillColor(255, 255, 255);
  pdf.rect(0, pageHeight - footerHeight, pageWidth, footerHeight, 'F');
  pdf.setDrawColor(180);
  pdf.setLineWidth(0.2);
  pdf.line(margin, pageHeight - footerHeight + 1.5, pageWidth - margin, pageHeight - footerHeight + 1.5);
  pdf.setFontSize(9);
  pdf.setTextColor(80, 80, 80);
  const label = footerText
    ? `${footerText}  ·  Page ${page} of ${totalPages}`
    : `Page ${page} of ${totalPages}`;
  pdf.text(label, pageWidth / 2, pageHeight - 5, { align: 'center' });
}

export function buildPagedPdfFromCanvas(canvas, _formEl, { footerText } = {}) {
  const pdf = new jsPDF({
    orientation: 'portrait',
    unit: 'mm',
    format: 'a4',
    compress: true,
  });
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const margin = 10;
  const footerHeight = 12;
  const contentWidth = pageWidth - margin * 2;
  const contentHeight = pageHeight - margin - footerHeight;
  const imgData = canvas.toDataURL('image/jpeg', 0.92);
  const imgHeight = (canvas.height * contentWidth) / canvas.width;

  let heightLeft = imgHeight;
  let position = margin;
  pdf.addImage(imgData, 'JPEG', margin, position, contentWidth, imgHeight);
  heightLeft -= contentHeight;

  while (heightLeft > 0.5) {
    position = margin - (imgHeight - heightLeft);
    pdf.addPage();
    pdf.addImage(imgData, 'JPEG', margin, position, contentWidth, imgHeight);
    heightLeft -= contentHeight;
  }

  const totalPages = pdf.internal.getNumberOfPages();
  for (let page = 1; page <= totalPages; page += 1) {
    pdf.setPage(page);
    paintPageFooter(pdf, {
      page,
      totalPages,
      footerText,
      pageWidth,
      pageHeight,
      margin,
      footerHeight,
    });
  }
  return pdf;
}

export async function captureElementCanvas(element) {
  return html2canvas(element, {
    ...CAPTURE_OPTIONS,
    windowWidth: Math.max(element.scrollWidth, element.clientWidth),
    windowHeight: Math.max(element.scrollHeight, element.clientHeight),
  });
}

export async function downloadFormPdf({ element, fileName, footerText }) {
  if (!element) {
    throw new Error('Report form not found.');
  }
  const previousOverflow = element.style.overflow;
  element.style.overflow = 'visible';
  try {
    const canvas = await captureElementCanvas(element);
    const pdf = buildPagedPdfFromCanvas(canvas, element, { footerText });
    downloadBlobFile(pdf.output('blob'), fileName);
  } finally {
    element.style.overflow = previousOverflow;
  }
}
